import { createAction, props } from '@ngrx/store';
import { ILegalDocumentsResponse } from '../models/legal-documents.model';

export const loadLegalDocumentsCurrent = createAction(
  '[LegalDocuments] Load Legal Documents Current',
  props<{ request: { customerId: string } }>()
);

export const loadLegalDocumentsCurrentSuccess = createAction(
  '[LegalDocuments] Load Legal Documents Current Success',
  props<{ response: ILegalDocumentsResponse[] }>()
);

export const loadLegalDocumentsCurrentFailure = createAction(
  '[LegalDocuments] Load Legal Documents Current Failure',
  props<{ error: Error | any }>()
);

export const loadLegalDocumentsPrevious = createAction(
  '[LegalDocuments] Load Legal Documents Previous',
  props<{ request: { customerId: string } }>()
);

export const loadLegalDocumentsPreviousSuccess = createAction(
  '[LegalDocuments] Load Legal Documents Previous Success',
  props<{ response: ILegalDocumentsResponse[] }>()
);

export const loadLegalDocumentsPreviousFailure = createAction(
  '[LegalDocuments] Load Legal Documents Previous Failure',
  props<{ error: Error | any }>()
);
